import React from 'react';
import {
  Brief,
  Button,
  CondensedMedium,
  CondensedSmall,
  Flashy,
  Grid,
  GridColumn,
  Gutter,
  IconButton,
  Layout,
  LayoutItem,
  Well,
} from '@axiom/ui';

import { ChatMetric } from '../../enums/chat-metric';
import { useSparkSession } from '../../hooks/useSparkSession';

export const ChatQueuedPrompts = () => {
  const {
    editQueuedPrompt,
    session: { queue },
  } = useSparkSession();
  const {
    dismissQueuedPrompt,
    dismissQueuedPrompts,
    editingPromptId,
    isQueuePaused,
    queuedPrompts,
  } = queue;

  if (queuedPrompts.length === 0) return null;

  return (
    <Gutter bottom="8px" gutterType="margin">
      <Layout direction="vertical" name="QUEUED_PROMPTS" verticalGutter="4px">
        <Layout
          horizontalGutter="8px"
          name="QUEUED_PROMPTS_HEADER"
          position="right middle"
        >
          <CondensedSmall>
            <Flashy color="textSubtle">
              {queuedPrompts.length === 1
                ? 'Queued prompt'
                : `Queued prompts (${queuedPrompts.length})`}
            </Flashy>
          </CondensedSmall>
          {isQueuePaused ? (
            <CondensedSmall name="QUEUE_PAUSED">
              <Flashy color="controlBrand">Paused - submit to continue</Flashy>
            </CondensedSmall>
          ) : null}
          {queuedPrompts.length > 1 ? (
            <Button
              name="DISMISS_QUEUED_PROMPTS"
              onClick={() => {
                dismissQueuedPrompts();
              }}
              pattern="secondary"
              variation="minimal"
            >
              Clear all
            </Button>
          ) : null}
        </Layout>
        <Grid>
          <GridColumn floated="right" width={5}>
            <Brief
              briefMaxHeight={ChatMetric.SHELF_MAX_HEIGHT}
              name="QUEUED_PROMPT_SHELF"
              position="right"
              variation="minimal"
            >
              <Layout
                direction="vertical"
                name="QUEUED_PROMPT_LIST"
                verticalGutter="4px"
              >
                {queuedPrompts.map(queued => {
                  const isEditing = queued.id === editingPromptId;

                  return (
                    <Well
                      background="light"
                      border
                      dimmed={isEditing}
                      key={queued.id}
                      name={`QUEUED_PROMPT_${queued.id}`}
                    >
                      <Layout horizontalGutter="8px" position="middle">
                        <LayoutItem fluid>
                          <CondensedMedium maxLines={2} maxLinesStrict>
                            <Flashy
                              color={isEditing ? undefined : 'textSubtle'}
                              name={`QUEUED_PROMPT_TEXT_${queued.id}`}
                            >
                              {queued.text}
                            </Flashy>
                          </CondensedMedium>
                        </LayoutItem>
                        <IconButton
                          disabled={isEditing}
                          icon="pencil"
                          name={`EDIT_QUEUED_PROMPT_${queued.id}`}
                          onClick={() => {
                            editQueuedPrompt(queued.id);
                          }}
                          title="Edit this prompt"
                          variation="minimal"
                        />
                        <IconButton
                          icon="x-mark"
                          name={`DISMISS_QUEUED_PROMPT_${queued.id}`}
                          onClick={() => {
                            dismissQueuedPrompt(queued.id);
                          }}
                          title="Dismiss this prompt"
                          variation="minimal"
                        />
                      </Layout>
                    </Well>
                  );
                })}
              </Layout>
            </Brief>
          </GridColumn>
        </Grid>
      </Layout>
    </Gutter>
  );
};
